export default {
  init() {
    // JavaScript to be fired on all pages



    var Header = {};

    Header.Scroll = function () {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
          $('header.banner').addClass('scrolled');
        }
        else {
          $('header.banner').removeClass('scrolled');
        }
      });
    }

    Header.Scroll();
  },
  finalize() {

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('.nav-item')

      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 120,
            }, 500, 'linear', function () {

            });
          }
        }
      });



    // $(document).on('click', '.toggle-site-selector', function (e) {
    //   e.preventDefault();
    //   $('html, body').animate({
    //     scrollTop: 0,
    //   }, 0, 'linear', function () {
    //   });
    //   $('.site-selector-toggler').dropdown('toggle');

    // });

    $(document).on('click', '.site-selector-toggler, .toggle-site-selector', function () {
      $('.site-selector-toggler').addClass('show');
      $('#site-dropdown').addClass('show');
    });

    $(document).on('click', '#site-dropdown .btn-close', function () {
      $('.site-selector-toggler').removeClass('show');
      $('#site-dropdown').removeClass('show');
    });




    $('.hamburger').click(function () {
      $(this).toggleClass('is-active');
      $('header.banner').toggleClass('expanded');

      // Close all sub dropdown on mobile
      if (isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');

        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');
      }
    });

    $(document).on('click', '.dropdown-menu .btn-close', function () {
      $(this).parents('.dropdown-wrap').find('.dropdown-toggle').dropdown('toggle');
    });

    // Back button main nav mobile
    $(document).on('click', '.main-nav-dropdown .back-button', function () {

      var parentItem = $(this).parents('.nav-item').first();
      if ($(this).parents('.sub-menu-level-1').length) {
        parentItem.find('.hover-dropdown-toggle').removeClass('show');
        parentItem.find('.hover-dropdown-menu').removeClass('show');
      }
      else {
        $(this).parents('.nav-item').first().find('>.dropdown-toggle.show').dropdown('toggle');
      }

    });

    // Close Btn on main nav dropdown
    $(document).on('click', '.main-nav-dropdown .btn-close', function () {
      $(this).parents('.nav-item').find('>.dropdown-toggle.show').dropdown('toggle');
    });

    // Hover on Main nav sub menu (desktop only)
    $(document).on('mouseover touch', '.main-nav-dropdown .sub-menu-level-1 >.nav-item >.nav-link', function () {
      if (!isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');
        $(this).parent('.nav-item').find('.hover-dropdown-menu').addClass('show');
        $(this).addClass('show');
        calculateMainMenuHeight();
      }
    });

    // Hover on Main Nav level 0
    $(document).on('mouseenter', '#menu-main >.nav-item >.nav-link', function () {

      if (!isMobileNavActive()) {
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');

        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');

        if ($(this).hasClass('dropdown-toggle')) {
          $(this).parent('.nav-item').find('.hover-dropdown-toggle').first().addClass('show');
          $(this).parent('.nav-item').find('.hover-dropdown-menu').first().addClass('show');
          calculateMainMenuHeight();
          $(this).addClass('show');
          $(this).parent('.nav-item').find('.dropdown-mega-menu').addClass('show');
        }
      }
    });

    // Main nav close dropdown on mouse leave
    $(document).on('mouseleave', '#menu-main >.nav-item', function () {
      if (!isMobileNavActive()) {
        $('#menu-main .dropdown-toggle.show').removeClass('show');
        $('#menu-main .dropdown-mega-menu.show').removeClass('show');
      }
    });

    // Main nav sublevel 1 - click on mobile 
    $(document).on('click', '#menu-main .sub-menu-level-1 >.nav-item >.nav-link.hover-dropdown-toggle', function (e) {
      if (isMobileNavActive()) {
        e.preventDefault();
        $('.main-nav-dropdown .hover-dropdown-menu.show').removeClass('show');
        $('.main-nav-dropdown .hover-dropdown-toggle.show').removeClass('show');
        $(this).parent('.nav-item').find('.hover-dropdown-menu').addClass('show');
        $(this).addClass('show');

      }
    });

    function isMobileNavActive() {
      var mobileNavBreakpoint = 992;
      if ($(window).width() < mobileNavBreakpoint) {
        return true;
      }
      return false;
    }

    function calculateMainMenuHeight() {
      var openedSubmenuDropdown = $('#menu-main .hover-dropdown-menu.show .sub-menu-wrap');
      var submenuHeight = 0;
      if (openedSubmenuDropdown.length) {
        submenuHeight = openedSubmenuDropdown.first().height();
      }
      $('#menu-main .main-nav-dropdown .navbar-nav').css('min-height', submenuHeight);
    }


    $(document).on('click', '.btn-add-download-cart', function (e) {
      e.preventDefault();

      var cartToast = $('#cartToast');
      var form = $('#add-to-cart-form');
      var data = form.serializeArray();
      data.push({
        name: 'document',
        value: $(this).data('document'),
      });

      $.ajax({
        data: data,
        method: 'POST',
        url: form.attr('action'),
        beforeSend: function () {
          //spinner.show();
        },
        success: function (response) {
          if (response.type == 'success') {
            $('.cart-toggle .counter').html(response.count);
            $('#cart-results').html(response.response);

            cartToast.find('.message').html(response.message);

            var toast = new bootstrap.Toast(cartToast);
            toast.show();
            
          } else {
            //window.location.replace(url);
          }
        },
        error: function () {
          //window.location.replace(url);
        },
        complete: function () {
          //spinner.hide();
        },
      });
    });

    $(document).on('click', '.btn-basket, .cart-toggle', function () {
      $('.cart-toggle').addClass('show');
      $('.cart-dropdown').addClass('show');
    });

    $(document).on('click', '.cart-dropdown .btn-close', function () {
      $('.cart-toggle').removeClass('show');
      $('.cart-dropdown').removeClass('show');
    });


    $(document).on('click', '.cart-item .cart-button.delete', function (e) {
      e.preventDefault();

      var form = $('#delete-from-cart-form');
      var data = form.serializeArray();
      data.push({
        name: 'document',
        value: $(this).data('document'),
      });

      $.ajax({
        data: data,
        method: 'POST',
        url: form.attr('action'),
        beforeSend: function () {
          //spinner.show();
        },
        success: function (response) {
          if (response.type == 'success') {
            $('.cart-toggle .counter').html(response.count);
            $('#cart-results').html(response.response);

          } else {
            //window.location.replace(url);
          }
        },
        error: function () {
          //window.location.replace(url);
        },
        complete: function () {
          //spinner.hide();
        },
      });
    });

  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js